import { useAppSelector } from "../../hooks/redux-hooks";
import ClassicRecordCTA, { type RecordCTAProps } from "./ClassicRecordCTA.component";
import QuickStartCTA from "./QuickStartCTA.component";

/** The sidebar's Start card: Quick Start for accounts on its Constance rollout, else the classic card. */
const RecordCTA = (props: RecordCTAProps) => {
  const quickStart = useAppSelector((state) => state.auth.userInfo.is_quick_start_enabled === true);
  return quickStart ? <QuickStartCTA {...props} /> : <ClassicRecordCTA {...props} />;
};

export default RecordCTA;
